import { ZButton } from "@/shared/components/button";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@nextui-org/react";

interface ReopenSessionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

const ReopenSessionModal = ({
  isOpen,
  onClose,
  onConfirm,
  loading,
}: ReopenSessionModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalContent>
        <ModalHeader className="self-center">
          <p className="text-[18px] font-semibold">
            Reopen Assessment?
          </p>
        </ModalHeader>
        <ModalBody className="self-center items-center">
          <p className="text-[#777780] text-tiny text-center">
            This assessment will be reopened for editing. You can mark it as complete again once you're done.
          </p>
        </ModalBody>
        <ModalFooter className="border-t">
          <ZButton
            color="primary"
            className="w-full"
            variant="bordered"
            onClick={onClose}
          >
            Cancel
          </ZButton>

          <ZButton
            color="primary"
            className="w-full"
            onClick={onConfirm}
            isLoading={loading}
          >
            Yes, Proceed
          </ZButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ReopenSessionModal;
